import React from "react";
import styled from "styled-components";
import { FaInstagram, FaYoutube, FaFacebookF, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Checkbox from "../UI/Checkbox";

const SocialMediaContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const SocialMediaTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--primary-color);
  font-family: "Cormorant Garamond", serif;
  letter-spacing: 1px;
`;

const SocialMediaGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 576px) {
    gap: 0.75rem;
  }
`;

const SocialMediaOption = styled.div`
  flex: 0 0 auto;
`;

// Platform icon colors data
const platformColors = {
  instagram: "#E1306C",
  youtube: "#FF0000",
  facebook: "#4267B2",
  twitter: "#FFFFFF",
  tiktok: "#FFFFFF",
};

// Social media platform data with icons
const platforms = [
  {
    id: "youtube",
    name: "YouTube",
    icon: (isSelected) => (
      <FaYoutube
        size={24}
        color={isSelected ? platformColors.youtube : "#6B7280"}
      />
    ),
  },
  {
    id: "instagram",
    name: "Instagram",
    icon: (isSelected) => (
      <FaInstagram
        size={24}
        color={isSelected ? platformColors.instagram : "#6B7280"}
      />
    ),
  },
  {
    id: "facebook",
    name: "Facebook",
    icon: (isSelected) => (
      <FaFacebookF
        size={20}
        color={isSelected ? platformColors.facebook : "#6B7280"}
      />
    ),
  },
  {
    id: "twitter",
    name: "X",
    icon: (isSelected) => (
      <FaXTwitter
        size={20}
        color={isSelected ? platformColors.twitter : "#6B7280"}
      />
    ),
  },
  {
    id: "tiktok",
    name: "TikTok",
    icon: (isSelected) => (
      <FaTiktok
        size={20}
        color={isSelected ? platformColors.tiktok : "#6B7280"}
      />
    ),
  },
];

const SocialMediaSelector = ({ selectedPlatforms, onChange, error }) => {
  const handleTogglePlatform = (platform) => {
    const currentSelection = [...selectedPlatforms];
    const platformIndex = currentSelection.indexOf(platform);

    if (platformIndex === -1) {
      // Add platform if not selected
      onChange([...currentSelection, platform]);
    } else {
      // Remove platform if already selected
      currentSelection.splice(platformIndex, 1);
      onChange(currentSelection);
    }
  };

  return (
    <SocialMediaContainer>
      <SocialMediaTitle>Select Social Media Platforms</SocialMediaTitle>
      <SocialMediaGrid>
        {platforms.map((platform) => {
          const isSelected = selectedPlatforms.includes(platform.id);

          return (
            <SocialMediaOption key={platform.id}>
              <Checkbox
                checked={isSelected}
                onChange={() => handleTogglePlatform(platform.id)}
                icon={platform.icon(isSelected)}
                iconOnly
              >
                {/* Platform name removed */}
              </Checkbox>
            </SocialMediaOption>
          );
        })}
      </SocialMediaGrid>
      {error && (
        <p
          style={{
            color: "var(--error-color)",
            fontSize: "0.85rem",
            marginTop: "0.5rem",
          }}
        >
          {error}
        </p>
      )}
    </SocialMediaContainer>
  );
};

export default SocialMediaSelector;
